import {
    SALES_LIST
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getSalesList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/SalesOrder/GetSalesOrderList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                dispatch({
                    type: SALES_LIST,
                    payload: result || {},
                });
                return result;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getSalesDetails = (payload) => {
    return dispatch => {
        const url = `v1/SalesOrder/GetSalesOrderByID?SalesOrderID=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const addSalesDetails = (payload) => {
    const url = `v1/SalesOrder/CreateSalesOrder`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await dispatch(getSalesList(payList));
            return result?.data;
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateSalesDetails = (payload) => {
    const url = `v1/SalesOrder/UpdateSalesOrder`;
    
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getSalesList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return false;
    });
};
